import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AxiosError } from 'axios'
import { getAxiosInstance } from 'services/api'
import { ValidationErrors } from 'store/types'
import { PrizeWinning, PrizeWinningSummary } from './types'

const api = getAxiosInstance()

/**
 * Get user's prize winnings
 */
export const getPrizeWinnings = createAsyncThunk<
  {
    winnings: PrizeWinning[]
    summary: PrizeWinningSummary
  },
  void,
  { rejectValue: ValidationErrors }
>('wallet/getPrizeWinnings', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/wallet/prize-winnings')
    return response.data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>
    if (!error.response) throw err
    return rejectWithValue(error.response.data)
  }
})

/**
 * Initiate PayPal OAuth connection
 */
export const initiatePayPalConnect = createAsyncThunk<
  { authUrl: string },
  void,
  { rejectValue: ValidationErrors }
>('wallet/initiatePayPalConnect', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/wallet/paypal/connect')
    return response.data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>
    if (!error.response) throw err
    return rejectWithValue(error.response.data)
  }
})

/**
 * Disconnect PayPal account
 */
export const disconnectPayPal = createAsyncThunk<
  { message: string },
  void,
  { rejectValue: ValidationErrors }
>('wallet/disconnectPayPal', async (_, { rejectWithValue }) => {
  try {
    const response = await api.post('/wallet/paypal/disconnect')
    return response.data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>
    if (!error.response) throw err
    return rejectWithValue(error.response.data)
  }
})
